import mergeMaps from "../../../utils/merge-maps";
import getDefaultParameters from "./get-default-parameters";
import getTriggerParameters from "./trigger/get-trigger-parameters";

/**
 *
 * @param {MainClassProps} main
 * @param {TriggerProps} trigger
 * @param {Map<"name" |"parameters", any>} data
 * @param {String} type
 * @param {Boolean} coordinates Is coordinates-based
 */
const setTriggerParameters = (main, trigger, data, type, coordinates) => {
  /** Custom parameters in a string (`start|x˸20%╳start|y˸40px`) */
  const parameters = data.get("parameters");

  const useBounds = type === "viewport";

  /** Default parameters */
  const defaults = /** @type {MergedTriggerParameterProps} */ (
    getDefaultParameters(trigger, type, coordinates)
  );

  /** Custom parameters */
  const custom = /** @type {MergedTriggerParameterProps} */ (
    getTriggerParameters(parameters, main, coordinates, useBounds)
  );

  /** Merge trigger parameters */
  const merged = mergeMaps(custom, defaults);

  trigger.set("parameters", merged);
};

export default setTriggerParameters;
